import { render, staticRenderFns } from "./datetime-local.vue?vue&type=template&id=2e8b2c73&"
import script from "./datetime-local.vue?vue&type=script&lang=js&"
export * from "./datetime-local.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports